import React, { useEffect } from "react";
import maintananceImg from "../assets/logo/maintanance-img.png";
import logo from "../assets/logo/inmate-white-logo.png";
import Button from "../components/common/ui/Button";
import "../assets/css/MaintenancePage.css";
import { history } from "../_helpers";
import { useDispatch } from "react-redux";
import { masterActions } from "../_store";
import Swal from "sweetalert2";

const MaintenancePage = () => {
  const dispatch = useDispatch();
  const loginInterval = 60000; // 1min once check

  useEffect(() => {
    Swal.close();
  }, []);

  const handleLoginFromMaintenance = () => {
    //check if maintenance mode is enabled or not
    dispatch(masterActions.MaintenanceMode("WEB"))
      .then((result) => {
        const data = result?.payload;
        // const data = { IsApplicationMaintenance: 1 };
        if (data == undefined ||
          Object?.keys(data).length === 0 ||
          data?.IsApplicationMaintenance === 1
        )
          return;
        if (
          Object?.keys(data).length > 0 &&
          data?.IsApplicationMaintenance === 0
        ) {
          history.navigate("/facilityuser"); window.location.reload();
        } else {
          history.navigate("/Admin/Maintenance");
        }
      })
      .catch((err) => {
        console.log("Error API")
      });
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleLoginFromMaintenance();
    }, loginInterval);

    return () => {
      clearInterval(intervalId);
    };
  }, []);


  return (
    <div className="parent-container">
      <div>
        <div className="inmate-logo">
          <img src={logo} alt="Logo" />
        </div>
        <div className="maintance-content  shadow-sm b-r-all ">
          <div className="">
            <img src={maintananceImg} alt="Logo" className="maintance-logo img" />
          </div>
          <p className='maintance-text' >
            This website is currently undergoing maintenance and will be back
            online shortly. Thank you for your patience.
          </p>
          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              className="mt-2"
              onClick={() => { handleLoginFromMaintenance() }}
              label="BACK TO LOGIN"
              type="button"
              status="primary"
            />
          </div>
        </div>
        <div className="maintance-footer">
          <p>Copyright © {new Date().getFullYear()} by inmate inbox. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MaintenancePage);
